var app = angular.module("ngmvac");
app.$inject = ['$scope', 'HotelFactory'];
app.controller("contactoController", function($scope, HotelFactory) {
    var vm = this;
    vm.nameContact="";
    vm.lastnameContact="";
    vm.emailContact="";
    vm.guardar_correo = function() {        
        correo = vm.emailContact;
        $validarc = validarEmail(correo);        
        if (vm.nameContact == "") {
            swal({
                title: "Debes ingresar un nombre.",
                imageUrl: "img/signoadmiracion.png",
                showConfirmButton: true,
                allowEscapeKey: false
            });
        } else if (vm.lastnameContact == "") {
            swal({
                title: "Debes ingresar apellido.",
                imageUrl: "img/signoadmiracion.png",
                showConfirmButton: true,
                allowEscapeKey: false
            });
        } else if (correo == "") {
            swal({
                title: "Debes ingresar un correo.",
                imageUrl: "img/signoadmiracion.png",
                showConfirmButton: true,
                allowEscapeKey: false
            });
        } else if ($validarc == "error") {
            swal({
                title: "Debes ingresar un correo Valido.",
                imageUrl: "img/signoadmiracion.png",
                showConfirmButton: true,
                allowEscapeKey: false
            });
        } else {
            HotelFactory.guardarcorreo(vm.nameContact, vm.lastnameContact, vm.emailContact).then(function(response) {
                // console.log(response.data);
                if (response.data == "ingresado") {
                    swal({
                        title: "Correo ingresado.",
                        type: "success",
                        showConfirmButton: true,
                        allowEscapeKey: false
                    });
                } else {
                    swal({
                        title: "Lo sentimos, el correo ya esta registrado.",
                        imageUrl: "img/signoadmiracion.png",
                        showConfirmButton: true,
                        allowEscapeKey: false
                    });
                }
                vm.nameContact="";
                vm.lastnameContact="";
                vm.emailContact="";
            });
        }
    }

    function validarEmail(valor) {
        if (/^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i.test(valor)) {
            return "correcto";
        } else {
            return "error";
        }
    }
});